/* eslint no-param-reassign: "error" */
import {
  createSlice,
} from '@reduxjs/toolkit';

import type { ContentJson } from './service/entity/contentEntity';
import type { EntityDataPubNotNullType } from '../entityPub';
import type { EntityDataPubType } from '@/domain/entityBase';
import type {
  SentNewsJsonPub,
  SentNewsJsonPvt,
} from '@/domain/news/service/entity/sentNewsEntity';
import type { DeleteOutputType, EntitySubscribeType } from '@/infra/appsync';
import type { NewsStateType } from '@/types/domain/news/redux';
import type {
  PayloadAction,
} from '@reduxjs/toolkit';

import { service } from '@/share';

const initialState: NewsStateType = {
  sentNewsList: [],
  sentNews: undefined,
  nextTokenSentNews: null,
};

/**
 * お知らせSlice
 */
export const newsSlice = createSlice({
  name: 'news',
  initialState,
  reducers: {
    /** お知らせリストをセット */
    setSentNewsList:
      (state, action: PayloadAction<{
        nextToken: string,
        items: Array<EntityDataPubType<SentNewsJsonPvt, SentNewsJsonPub>>,
      }>) => {
        state.sentNewsList = action.payload.items;
        state.nextTokenSentNews = action.payload.nextToken;
      },
    /** 送信済みお知らせをセット */
    setSentNews:
      (state, action: PayloadAction<{
        content: ContentJson;
        info: EntityDataPubNotNullType<SentNewsJsonPvt, SentNewsJsonPub>;
      } | undefined>) => {
        state.sentNews = action.payload;
      },
    /** 作成 */
    createSentNewsStore: (state, action: PayloadAction<EntitySubscribeType>) => {
      state.sentNewsList = service.news.createSentNewsStore(
        state.sentNewsList,
        action.payload,
        undefined,
      );
      // Push通知実装に伴い廃止
      // // eslint-disable-next-line @typescript-eslint/no-floating-promises
      // navigator.serviceWorker.ready.then((registration) => {
      //   if (registration.active) {
      //     const data = JSON.parse(action.payload.data);
      //     const title = '新着のお知らせ';
      //     const body = `件名：「${data.title as string}」`;
      //     registration.active.postMessage({ title, body, type: 'NOTIFICATION' });
      //   }
      // });
    },
    /** 更新 */
    updateSentNewsStore: (state, action: PayloadAction<EntitySubscribeType>) => {
      state.sentNewsList = service.news.updateSentNewsStore(
        state.sentNewsList,
        action.payload,
      );
    },
    /** 削除 */
    deleteSentNewsStore: (state, action: PayloadAction<DeleteOutputType>) => {
      state.sentNewsList = service.news.deleteSentNewsStore(
        state.sentNewsList,
        action.payload,
      );
    },
  },
});
